import { Injectable } from '@angular/core';
import { Allocation, AllocationFilterInput, AllocationPartenaireStatut } from '@lib/models/generated/graphql';
import { gql } from 'apollo-angular';
import { QueryManagerService } from 'finzzle-angular-utils';
import { BehaviorSubject, lastValueFrom } from 'rxjs';

export const ALL_ALLOCATIONS = gql`
  query allocations($where: AllocationFilterInput) {
    allocations(where: $where) {
      id
      libelle
      niveauDeRisque
      storageFileId
      dateModification
      modeDeGestionCode
      storageFile {
        id
        fileName
      }
    }
  }
`;

export const UPDATE_ALLOCATION_STORAGE_FILE = gql`
  mutation updateAllocationStorageFile($allocationId: String!, $storageFileId: String) {
    updateAllocationStorageFile(allocationId: $allocationId, storageFileId: $storageFileId) {
      id
      libelle
      niveauDeRisque
      dateModification
      storageFileId
      modeDeGestionCode
      storageFile {
        id
        fileName
      }
    }
  }
`;
export type DataAllocation = {
  allocations: Allocation[];
  loading: boolean;
};
@Injectable({
  providedIn: 'root',
})
export class AllocationService {
  public allocationsSubject: BehaviorSubject<DataAllocation> = new BehaviorSubject<DataAllocation>({
    allocations: [],
    loading: false,
  });
  constructor(private queryManager: QueryManagerService) {}

  loadAllAllocations() {
    this.allocationsSubject.next({ allocations: [], loading: true });
    const filter: AllocationFilterInput = { statut: { eq: AllocationPartenaireStatut.Actif } };
    this.queryManager
      .query<{ allocations: Allocation[] }>({
        query: ALL_ALLOCATIONS,
        variables: { where: filter },
        fetchPolicy: 'network-only',
      })
      .subscribe(result => {
        this.allocationsSubject.next({
          allocations: result?.data?.allocations ?? [],
          loading: false,
        });
      });
  }

  public async updateAllocationStorageFile(allocationId: string, storageFileId: string | null) {
    const result = await lastValueFrom(
      this.queryManager.mutate<{ updateAllocationStorageFile: Allocation }>({
        mutation: UPDATE_ALLOCATION_STORAGE_FILE,
        variables: { allocationId, storageFileId },
      })
    );
    if (result.data?.updateAllocationStorageFile) {
      this.loadAllAllocations();
    }
  }
}
